import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Zustand store for managing authentication and user-related states and actions.
 */
export const useConnection = create(
  persist(
    (set) => ({
      // Authentication States
      authToken: "",
      authenticated: false,
      signedUp: false,
      authUser: null,
      emailVerified: null,
      _hasHydrated: false,
      role: null,
      students: null,

      // User Management States
      users: [], // Initialize as an empty array

      // Authentication Actions
      setStudents: (students) => set({ students }),
      setAuthToken: (authToken) => set({ authToken }),
      setAuthUser: (authUser) => set({ authUser }),
      setEmailVerified: (status) => set({ emailVerified: status }),
      toggleSignedUp: () => set({ signedUp: true }),
      disConnectAuthUser: () =>
        set({
          authToken: "",
          authenticated: false,
          authUser: null,
          role: null,
          users: [], // Optionally clear users on logout
        }),
      setHasHydrated: (state) => set({ _hasHydrated: state }),
      setRole: (role) => set({ role }),

      // User Management Actions
      getUsers: (users) => set({ users }), // Renamed from getUsers
      addUserToStore: (newUser) =>
        set((state) => ({
          users: [...state.users, newUser],
        })),
      removeUserFromStore: (userId) =>
        set((state) => ({
          users: state.users.filter((user) => user.id !== userId),
        })),
      updateUserInStore: (updatedUser) =>
        set((state) => ({
          users: state.users.map((user) =>
            user.id === updatedUser.id ? updatedUser : user
          ),
        })),
    }),
    {
      name: "connection-storage",
      getStorage: () => localStorage,
      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
        authToken: state.authToken,
        authUser: state.authUser,
        role: state.role,
        users: state.users, // Persist users as well
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
